import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const InformacionPago = ({ informacionPago }) => {
    const getFormaPagoStyle = (formaPago) => {
        if (!formaPago) return {};
        
        // Formas de pago electrónicas bancarizadas según catálogo SAT
        const formasElectronicas = ['03', '04', '28', '29', '05'];
        const codigo = formaPago.substring(0, 2);
        const isElectronica = formasElectronicas.includes(codigo);
        
        return {
            color: isElectronica ? '#28a745' : 'red',
            fontWeight: 'bold'
        };
    };

    return (
        <>
            {/* DISEÑO PARA DESKTOP/TABLET (lg y superiores - 992px+) */}
            <div className="d-none d-lg-block">
                <Card className="mb-3 border">
                    <Card.Header className="bg-light py-2">
                        <strong>INFORMACIÓN DEL PAGO</strong>
                    </Card.Header>
                    <Card.Body className="py-2">
                        <Row>
                            <Col xs={6}>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Versión Pagos:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{informacionPago?.versionPagos}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Monto Total Pagos:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${informacionPago?.montoTotalPagos}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">TotalTrasladoBaseIVA16:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${informacionPago?.totalTrasladoBaseIVA16}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">TotalTrasladoImpuestoIVA16:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>${informacionPago?.totalTrasladosImpuestoIVA16}</small>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={6}>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Fecha de pago:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{informacionPago?.fechaPago}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Forma de pago:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small style={getFormaPagoStyle(informacionPago?.formaDePagoP)}>
                                            {informacionPago?.formaDePagoP}
                                        </small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Moneda Pago:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small>{informacionPago?.monedaP}</small>
                                    </Col>
                                </Row>
                                <Row className="mb-1">
                                    <Col xs={5}>
                                        <small className="fw-bold">Monto:</small>
                                    </Col>
                                    <Col xs={7}>
                                        <small className="border p-1">${informacionPago?.monto}</small>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>

            {/* DISEÑO PARA MÓVIL (menor a 992px) */}
            <div className="d-block d-lg-none">
                <Card className="mb-2 border">
                    <Card.Header className="bg-light py-1">
                        <strong style={{ fontSize: "0.75rem" }}>INFORMACIÓN DEL PAGO</strong>
                    </Card.Header>
                    <Card.Body className="p-2">
                        <div style={{ fontSize: "0.65rem", lineHeight: "1.3" }}>
                            <div className="mb-2">
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Versión Pagos:</span>
                                    <span>{informacionPago?.versionPagos}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Fecha de pago:</span>
                                    <span>{informacionPago?.fechaPago}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Forma de pago:</span>
                                    <span style={getFormaPagoStyle(informacionPago?.formaDePagoP)}>
                                        {informacionPago?.formaDePagoP}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Moneda:</span>
                                    <span>{informacionPago?.monedaP}</span>
                                </div>
                            </div>

                            <div className="border-top pt-1">
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Monto Total Pagos:</span>
                                    <span className="fw-bold">${informacionPago?.montoTotalPagos}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Base IVA16:</span>
                                    <span>${informacionPago?.totalTrasladoBaseIVA16}</span>
                                </div>
                                <div className="d-flex justify-content-between">
                                    <span className="text-muted">Impuesto IVA16:</span>
                                    <span>${informacionPago?.totalTrasladosImpuestoIVA16}</span>
                                </div>
                                <div className="d-flex justify-content-between bg-light px-1 mt-1">
                                    <span className="fw-bold">Monto:</span>
                                    <span className="fw-bold text-primary">${informacionPago?.monto}</span>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    );
};

InformacionPago.propTypes = {
    informacionPago: PropTypes.shape({
        versionPagos: PropTypes.string,
        montoTotalPagos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladoBaseIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        totalTrasladosImpuestoIVA16: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        fechaPago: PropTypes.string,
        formaDePagoP: PropTypes.string,
        monedaP: PropTypes.string,
        monto: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
};

export default InformacionPago;
